import { Grid, Typography } from "@mui/material";
import { ArrowDownIcon } from "../../../../../../../assets/images";
import { MuiIconButton } from "../../../../../../../builderPackage/components";
import { MuiStack } from "../../../../../../../components";
var WarehouseCell = function (props) {
    var rowData = props.rowData, onButtonClick = props.onButtonClick;
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        justifyContent: 'center'
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        justifyContent: 'center',
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 11
    }, rowData ? rowData === null || rowData === void 0 ? void 0 : rowData.map(function (data) { /*#__PURE__*/ return React.createElement(Typography, {
        color: '#8593A3',
        fontSize: '12px'
    }, data === null || data === void 0 ? void 0 : data.LocationName); }) : /*#__PURE__*/ React.createElement(Typography, {
        color: '#8593A3',
        fontSize: '12px'
    }, "Select Location")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 1
    }, /*#__PURE__*/ React.createElement(MuiIconButton, {
        onClick: onButtonClick,
        style: {
            alignContent: 'flex-end'
        }
    }, /*#__PURE__*/ React.createElement("img", {
        src: ArrowDownIcon,
        alt: "Arrow Down"
    })))));
};
export default WarehouseCell;
